import { imageFragment } from './image'
import { seoFragment } from './seo'

const productFragment = `#graphql
  fragment singleProduct on Product {
    id
    availableForSale
    handle
    title
    description
    descriptionHtml
    vendor
    options {
      id
      name
      values
    }
    featuredImage {
      ...singleImage
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    variants(first: 250) {
      edges {
        node {
          id
          title
          quantityAvailable
          availableForSale
          selectedOptions {
            name
            value
          }
          image {
            url
          }
          price {
            amount
            currencyCode
          }
        }
      }
    }
    images(first: 20) {
      edges {
        node {
          ...singleImage
        }
      }
    }
    seo {
      ...seo
    }
    tags
    updatedAt
    createdAt
  }
  ${imageFragment}
  ${seoFragment}
`

export { productFragment }
